export const customStyles = {
  header: {
    style: {
      fontSize: '17px',
      fontWeight: 'bold',
      minHeight: '40px',
      paddingLeft: '16px',
      paddingRight: '8px',
      borderRadius: '20px 20px 0 0',
      textWrap: "nowrap"
    }
  },
  headRow: {
    style: {
      backgroundColor: '#637BFE',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 'bold',
      minHeight: '40px',
      borderRadius: '0 0 20px 20px',
      borderBottom: 'none',
      alignItems: 'center',
      textAlign: 'center',
      textWrap: "nowrap"
    },
    denseStyle: {
      minHeight: '32px'
    }
  },
  subHeader: {
    style: {
      minHeight: '0px',
      marginTop: -14,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.09)'
    }
  },
  headCells: {
    style: {
      fontSize: '14px',
      color: 'white',
      fontWeight: 'bold',
       '&:nth-of-type(2)': { // Targeting the 2nd header cell (index 1)
        minWidth: '110px',
        textAlign: 'left', // Align name header to left if data is left aligned
      },
      // Column 2: 'Order Date'
      '&:nth-of-type(3)': { // Targeting the 3rd header cell (index 2)
        minWidth: '100px', // Adjusted for date clarity
        textAlign: 'center',
      },
      // Column 3: 'Delivery Date'
      '&:nth-of-type(4)': { // Targeting the 4th header cell (index 3)
        minWidth: '110px',
        textAlign: 'center',
      },
      // Column 4: 'Amount'
      '&:nth-of-type(5)': { // Targeting the 5th header cell (index 4)
        minWidth: '80px', // Adjust as needed for currency
        textAlign: 'right', 
      },
      // Column 5: 'Order Status'
      '&:nth-of-type(6)': { // Targeting the 6th header cell (index 5)
        minWidth: '150px',
        textAlign: 'center',
      },
      // Column 6: 'Worker Status'
      '&:nth-of-type(7)': { // Targeting the 7th header cell (index 6)
        minWidth: '150px',
        textAlign: 'center',
      },
      // Column 7: 'Worker Email'
      '&:nth-of-type(8)': { // Targeting the 8th header cell (index 7)
        minWidth: '250px',
        textAlign: 'left', 
      },
      // Column 8: 'Locked Rider Email'
      '&:nth-of-type(9)': { // Targeting the 9th header cell (index 8)
        minWidth: '200px',
        textAlign: 'left',
      },
      // Column 9: 'Delivery Address'
      '&:nth-of-type(10)': { // Targeting the 10th header cell (index 9)
        minWidth: '300px',
        textAlign: 'left',
      },
      // '&:first-of-type': { // Target the first column (Order ID) header cell
      //   minWidth: '100px', // Set the width specifically for Order ID column
      // },
    }
  },
  fixedHeader: { // New style for fixed header cells
    style: {
      backgroundColor: '#637BFE',
      color: '#FFFFFF',
      fontSize: '16px',
      fontWeight: 'bold',
      minHeight: '40px',
      minWidth: "100px !important", // Adjust based on your content
      borderBottom: 'none',
      textAlign: 'center',
      textWrap: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  rows: {
    style: {
      fontSize: '13px', 
      fontFamily: ['Euclid Circular A', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
      fontOpticalSizing: "auto",
      fontWeight: 400,
      fontStyle: "normal",
      color: "black",
      minHeight: '50px',
      minWidth: "100px !important", // Adjust based on your content
      textAlign: 'center',
      whiteSpace: 'normal', // Allow text wrapping
      wordWrap: 'break-word', // Break long words and wrap text to fit container
      wordBreak: 'break-word', // Break words at allowed break points to prevent overflow
      '&:not(:last-of-type)': {
        borderBottomStyle: 'solid',
        borderBottomWidth: '0px'
      },
      '&:hover': {
        backgroundColor: '#f9fafc'
      }
    }
  },
  pagination: {
    style: {
      fontSize: '13px',
      minHeight: '50px',
      borderRadius: '0 0 20px 20px',
      textAlign: 'left'
    },
    pageButtonsStyle: {
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: 'red',
        fill: '#5A5858'
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#EBF1FEd'
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#3E79F7'
      }
    }
  }
};
